import { apiSlice } from '@services/apiSlice';
import { CountrySelector as endpoints } from '@services/endpoints';
import { CounstrySelectorData } from './CountrySelector.types';


const countrySelectorApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchCountrySelectList: build.query<CounstrySelectorData, void>({
      query: () => ({
        url: endpoints.fetchCountrySelectList,
        params: { language: window.lang, pageId: window.pageId }
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useFetchCountrySelectListQuery } = countrySelectorApi;